(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-product-detail-images"] && !Shopify.designMode) return;
  try {
    
  const initializeProductDetails = (scope = document) => {
    scope.querySelectorAll('[data-sp-product-details]:not([data-initialized])').forEach((details) => {
      details.dataset.initialized = 'true';
      const updateDetails = () => {
        if (details.open) {
          details.querySelectorAll('img[data-src]').forEach((image) => {
            image.src = image.dataset.src;
            image.removeAttribute('data-src');
          });
        }

      };

      details.addEventListener('toggle', updateDetails);
      updateDetails();
    });
  };

  initializeProductDetails();
  document.addEventListener('shopify:section:load', (event) => initializeProductDetails(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-related-products"] && !Shopify.designMode) return;
  try {
    
  const initSpRelatedCarousel = (scope = document) => {
    scope.querySelectorAll('.sp-related-products__carousel-wrap:not([data-initialized])').forEach((wrap) => {
      wrap.dataset.initialized = 'true';
      const track = wrap.querySelector('[data-sp-related-track]');
      const prevBtn = wrap.querySelector('[data-sp-related-prev]');
      const nextBtn = wrap.querySelector('[data-sp-related-next]');
      if (!track || !prevBtn || !nextBtn) return;

      const step = () => {
        const card = track.querySelector('.sp-related-products__card');
        if (!card) return 0;
        const style = getComputedStyle(track);
        const gap = parseFloat(style.columnGap || style.gap || '16');
        return card.getBoundingClientRect().width + gap;
      };

      const updateNav = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        prevBtn.hidden = track.scrollLeft <= 4;
        nextBtn.hidden = track.scrollLeft >= maxScroll - 4;
      };

      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
    });
  };

  initSpRelatedCarousel();
  document.addEventListener('shopify:section:load', (event) => initSpRelatedCarousel(event.target));

  } catch(e) { console.error(e); }
})();
})();
